var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"mb-5 mt-n2",attrs:{"cols":"12"}},[_c('div',{staticStyle:{"width":"100%","height":"370px"},attrs:{"id":"activity"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }